import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import SitesLocationMap from "./sites-location-map";
import Geocode from "react-geocode";

const LocationMapPopup = (props: any) => {
  const [flagErrors, setFlagErrors] = useState(false);
  const [radioCheck, setRadioCheck] = useState<any>("cordinates");
  const [addressInput, setAddressInput] = useState("");
  // setModalVisible(false)
  
  const {
    modalVisible,
    setModalVisible,
    mapPopupInput,
    setMapPopupInput,
    handleInput,
    mapData,
    setMapData,
    handleMapLatLon,
  } = props;

  const handleMapUpdate = () => {
    let checkEnteredValue = mapPopupInput;
    let flag_errors = false;
    if (
      checkEnteredValue === "" ||
      checkEnteredValue === null ||
      checkEnteredValue === undefined
    ) {
      flag_errors = true;
      setFlagErrors(true);
    } else {
      let temp_check_array = checkEnteredValue.split(",");
      if (temp_check_array.length <= 1 || temp_check_array.length > 2) {
        flag_errors = true;
        setFlagErrors(true);
      } else {
        let number1 = Number(temp_check_array[0]);
        let number2 = Number(temp_check_array[1]);

        if (
          isNaN(number1) ||
          isNaN(number2) ||
          number2 === 0 ||
          number1 === 0
        ) {
          flag_errors = true;
          setFlagErrors(true);
        } else {
          // set number1 and number 2 here.
          setFlagErrors(false);
          setMapData({
            lati: number1,
            lon: number2,
          });
        }
      }
    }
  };

  const handleClearField = () => {
    setMapPopupInput("");
    setFlagErrors(false);
  };

  const handleAddressInput = (e: any) => {
    const address = e.target.value;
    setAddressInput(address);
    /*  Geocode.setApiKey("AIzaSyCdsXnMXcV_vTCPjTd5tHGCi2Oed3hVKEQ");

    // set response language. Defaults to english.
    Geocode.setLanguage("en");
    // A Geocoding request with region=es (Spain) will return the Spanish city.
    Geocode.setRegion("es");
    // And according to the below google docs in description, ROOFTOP param returns the most accurate result.
    Geocode.setLocationType("ROOFTOP");
    // Enable or disable logs. Its optional.
    Geocode.enableDebug();
    // Get latitude & longitude from address.
    Geocode.fromAddress("Eiffel Tower").then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        console.log(lat, lng);
      },
      (error) => {
        console.error(error);
      }
    ); */
  };
  return (
    <>
      <Dialog
        header="Select Location"
        visible={modalVisible}
        modal={false}
        onHide={() => setModalVisible(false)}
        className="locationMapModal"
      >
        <div className="latlong-modalWrapper">
          <div className="latlong-fieldBlock">
            <div className="address-labels">
              <label className="form-label">
                <input
                  type="radio"
                  name="switchfield"
                  checked={radioCheck === "cordinates"}
                  className="form-check-input"
                  onChange={() => setRadioCheck("cordinates")}
                />{" "}
                Search by Co-Ordinates
              </label>
              {/* <label className="form-label">
                <input
                  type="radio"
                  name="switchfield"
                  checked={radioCheck === "location"}
                  className="form-check-input"
                  onChange={() => setRadioCheck("location")}
                />{" "}
                Search by Location
              </label> */}
            </div>
            {radioCheck === "cordinates" && (
              <div className="input-group">
                <input
                  type="text"
                  value={mapPopupInput}
                  name="location"
                  placeholder="Latitude,Longitude"
                  className="form-control"
                  autoComplete="new-password"
                  spellCheck={false}
                  onChange={(e: any) => {
                    handleInput(e);
                    handleMapUpdate();
                  }}
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleMapUpdate}
                >
                  Update map
                </button>
              </div>
            )}
            {
              radioCheck === "location" && (
                <div className="input-group">
                  <input
                    type="text"
                    value={addressInput}
                    name="location"
                    placeholder="Enter Location"
                    className="form-control"
                    autoComplete="new-password"
                    spellCheck={false}
                    onChange={(e: any) => handleAddressInput(e)}
                  />
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={handleMapUpdate}
                  >
                    Update map
                  </button>
                </div>
              )
              /* {flagErrors && (
              <span className="error-text">
                Please enter comma separated Lat/long
              </span>
            )}  */
            }
            {flagErrors && (
              <span className="error-text">
                Please enter comma separated Lat/long
              </span>
            )}
          </div>
          <div className="location-map">
            <SitesLocationMap
              setMapPopupInput={setMapPopupInput}
              mapData={mapData}
              setMapData={setMapData}
            />
            <div className="location-btngrp">
              <button
                className="btn btn-warning"
                type="button"
                onClick={handleClearField}
              >
                Clear Selection
              </button>
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => {
                  handleMapUpdate();
                  handleMapLatLon();
                }}
              >
                Submit
              </button>
              <button
                className="btn btn-light"
                type="button"
                onClick={() => {
                  setModalVisible(false);
                  setFlagErrors(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default LocationMapPopup;
